import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  claimLeaves: [],
  isLoaded: false,
};

export const claimLeavesSlice = createSlice({
  name: 'claimLeaves',
  initialState,
  reducers: {
    setClaimLeavesList: (state, action) => {
      state.claimLeaves = action.payload;
      state.isLoaded = true;
    },
  },
});
